const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case 'SET_INITIAL_DATA':
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/src/reducers/Initial.js